import BaseApi from "./BaseApi";
import ApiHelper from "../helpers/ApiHelper";
import db from "../resources/db.json";

/**
 * 定数APIクラス
 *
 * @class ConstantApi
 * @extends {BaseApi}
 */
class ConstantApi extends BaseApi {
  /**
   * 職場一覧を取得する
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async getWorkPlaces() {
    return { data: db["work-place-list"] };

    const axios = this.createRequest({
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return new ApiHelper(this).requestWithApiTokenAutoRefreshMechanism(
      async () => axios.get(`/work-place-list`),
    );
  }
  /**
   * 機種一覧を取得する
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async getModelTypes() {
    return { data: db["model-type-list"] };

    const axios = this.createRequest({
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return new ApiHelper(this).requestWithApiTokenAutoRefreshMechanism(
      async () => axios.get(`/model-type-list`),
    );
  }
  /**
   * 機種一覧を取得する
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async getModelNumbers() {
    return { data: db["model-number-list"] };

    const axios = this.createRequest({
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return new ApiHelper(this).requestWithApiTokenAutoRefreshMechanism(
      async () => axios.get(`/model-number-list`),
    );
  }
  /**
   * 工程一覧を取得する
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async getWorkProcesses() {
    return { data: db["work-process-list"] };

    const axios = this.createRequest({
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return new ApiHelper(this).requestWithApiTokenAutoRefreshMechanism(
      async () => axios.get(`/work-process-list`),
    );
  }
  /**
   * 停止ロス一覧を取得する
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async getStopLosses() {
    return { data: db["stop-loss-list"] };

    const axios = this.createRequest({
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return new ApiHelper(this).requestWithApiTokenAutoRefreshMechanism(
      async () => axios.get(`/stop-loss-list`),
    );
  }
  /**
   * 間接作業一覧を取得する
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async getIndirectWorks() {
    return { data: db["indirect-work-list"] };

    const axios = this.createRequest({
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return new ApiHelper(this).requestWithApiTokenAutoRefreshMechanism(
      async () => axios.get(`/stop-loss-list`),
    );
  }
  /**
   * 無負荷作業一覧を取得する
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async getNoloadWorks() {
    return { data: db["noload-work-list"] };

    const axios = this.createRequest({
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    return new ApiHelper(this).requestWithApiTokenAutoRefreshMechanism(
      async () => axios.get(`/stop-loss-list`),
    );
  }
}
export default ConstantApi;
